import React, { useCallback, useEffect } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

import {
  getBrief,
  loadBrief,
} from '@disco/state-management/reducers/entities/briefs'
import DocumentHeadTags from 'components/document-head-tags'
import { useDispatch, useSelector } from 'hooks/use-redux'
import BriefSettingsModal from '../../components/brief-settings-modal'

const BriefSettingsPage: React.FC = () => {
  const dispatch = useDispatch()
  const params = useParams<{ briefId: string }>()
  const location = useLocation()
  const navigate = useNavigate()

  const briefId = parseInt(params.briefId)

  const brief = useSelector(state => getBrief(state, { briefId }))

  useEffect(() => {
    if (!brief?.notify_user_ids) {
      dispatch(loadBrief(briefId))
    }
  }, [dispatch, briefId, brief?.notify_user_ids])

  const basePath = location.pathname.includes('brief-editor-v2')
    ? `/brief-editor-v2/${brief?.id}`
    : '/briefs'

  const handleCloseModal = useCallback(() => {
    navigate(basePath)
  }, [navigate, basePath])

  return (
    <div>
      <DocumentHeadTags title="Brief Settings | DISCO" />
      {brief && (
        <BriefSettingsModal
          briefId={params.briefId}
          onClose={handleCloseModal}
          notificationsLoading={brief.notify_user_ids === undefined}
          emailNotificationEnabled={brief.enable_email_notifications}
          notifyUserIds={brief.notify_user_ids}
        />
      )}
    </div>
  )
}

export { BriefSettingsPage }
export default BriefSettingsPage
